import React from "react";
import { Dropdown, DropdownButton, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class StudentFileProposalsActionCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.onDownloadSubmission = this.onDownloadSubmission.bind(this);
    this.onAcceptSubmission = this.onAcceptSubmission.bind(this);
    this.onRejectSubmission = this.onRejectSubmission.bind(this);
    this.showDownloadOption = this.showDownloadOption.bind(this);
    this.onDownloadSubmission = this.onDownloadSubmission.bind(this);
  }


  onAcceptSubmission() {
    this.props.onAcceptSubmission(this.props.proposal._id);
  }

  onRejectSubmission() {
    this.props.onRejectSubmission(this.props.proposal._id);
  }

  onDownloadSubmission() {
    this.props.onDownloadSubmission(this.props.proposal);
  }

  showDownloadOption() {
    return (
        !this.props.proposal.isAccepted
        && ((this.props.examinationStatus >= 50 && this.props.examinationStatus <= 53)
        || this.props.examinationStatus === 1
        || (this.props.examinationStatus >= 10 && this.props.examinationStatus <= 32))
    );
  }

  showAcceptOption() {
    return (
      !this.props.proposal.isAccepted
          && (this.props.examinationStatus === 1 || (this.props.examinationStatus >= 50 && this.props.examinationStatus <= 53))
    );
  }

  showRejectOption() {
    return (
      !this.props.proposal.isAccepted
      && (this.props.examinationStatus === 1 || (this.props.examinationStatus >= 50 && this.props.examinationStatus <= 53))
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Row style={{ marginRight: "-12px", float: "right" }}>
        <div style={{}}>
          <DropdownButton
            size="sm"
            onClick={event => event.stopPropagation()}
            id="dropdown-basic-button"
            title={<FontAwesomeIcon icon={faCogs} />}
            className="btn-green"
            disabled={!this.showDownloadOption()}
          >
            {this.showDownloadOption() && <Dropdown.Item onClick={this.onDownloadSubmission}>
              {t(
                "SingleExamination.StudentFileProposalsTab.ActionCell.DownloadOption"
              )}
            </Dropdown.Item>}
            {this.showAcceptOption() && (
              <Dropdown.Item onClick={this.onAcceptSubmission}>
                {t(
                  "SingleExamination.StudentFileProposalsTab.ActionCell.AcceptOption"
                )}
              </Dropdown.Item>
            )}
            {this.showRejectOption() && (
              <Dropdown.Item onClick={this.onRejectSubmission}>
                {t(
                  "SingleExamination.StudentFileProposalsTab.ActionCell.RejectOption"
                )}
              </Dropdown.Item>
            )}
          </DropdownButton>
        </div>
      </Row>
    );
  }
}

export default withTranslation()(StudentFileProposalsActionCell);
